import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-c5-five-two-two-one',
  templateUrl: './c5-five-two-two-one.component.html',
  styleUrls: ['./c5-five-two-two-one.component.scss']
})
export class C5FiveTwoTwoOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
